import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid } from "@mui/material";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import swal from "sweetalert";
import {
  makePostRequest,
  makeGetRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Zoom from "react-medium-image-zoom";
// import MicIcon from "@mui/icons-material/Mic";
// import TextEditor from "../NoticeBoard/TextEditor";
import { Editor } from "@tinymce/tinymce-react";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import avtarPic from "../../../assets/Images/avtarPic.png";

const Validation_Schema = Yup.object().shape({
  noticeTitle: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required"),
  noticeDesc: Yup.string(),
  radiovalue: Yup.string(),
});

function CreateNoticeModal({ onSubmitModal }) {
  const [noticeTitle, setnoticeTitle] = useState("");
  const [noticeDesc, setnoticeDesc] = useState("");
  const [membersIds, setMembersIds] = useState([]);
  const [radiovalue, setradioValue] = useState("");
  // const [isPublished, setIsPublished] = useState(false);
  const [isIndividual, setIsIndividual] = useState(false);
  const [status, setStatus] = useState("");
  const [isAutoArchived, setIsAutoArchived] = useState(true);
  // const [archivedTime, setArchivedTime] = useState();

  const [attachment, setAttachment] = useState([]);
  const [, setFilename] = useState("");
  const [q, setQ] = React.useState("");
  const [errnoticeDesc, seterrnoticeDesc] = React.useState(false);
  const [errradio, seterrradio] = React.useState(false);
  const [errpublish, seterrpublish] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [Upload, setUpload] = useState(false);
  const [noticeId, setnoticeId] = useState();
  const [noticeStatus, setnoticeStatus] = useState("");
  // const [radiobtnvalue, setradiobtnvalue] = useState("");
  const [docErrorMsg, setDocErrorMsg] = React.useState("");
  const [userflg] = React.useState("");
  const [showerr, setshowerr] = React.useState(false);

  let memberArr = [];

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  if (localStorage.getItem("isEditNotice")) {
    var formikInitials = {
      noticeTitle: noticeTitle,
      noticeDesc: noticeDesc,
      radiovalue: status,
      isAutoArchived: isAutoArchived,
      membersIds: membersIds,
    };
  } else {
     formikInitials = {
      noticeTitle: "",
      noticeDesc: "",
      radiovalue: "",
    };
  }

  async function addNoticeBoard() {
    // e.preventDefault();
    var inputdata = "";
    // let tempMemId;
    // return false;
    if (isEditNotice) {
      if (noticeDesc === "") {
        seterrnoticeDesc(true);
        return false;
      } else {
        seterrnoticeDesc(false);
      }


      if (noticeStatus === "draft" || (radiovalue === "individual" && membersIds.length > 0)) {
        setshowerr(false);
        inputdata = {
          notice_id: noticeId,
          notice_title: noticeTitle,
          notice_description: noticeDesc,
          attachment: attachment,
          member_id: membersIds,
          notice_visible_flag: radiovalue,
          is_auto_archived: isAutoArchived,
          created_at: new Date(),
        };
        await makePostRequest("commonapis/updateNotice", inputdata)
          .then((response) => {
            if (response.status === 201) {
              swal("Success", "Notice Updated successfully", "success", {
                timer: 1000,
                buttons: false,
              });
              // window.location.reload();
              onSubmitModal();
              setShowLoader(false)
            }
          })
          .catch((err) => {
            setShowLoader(false)
            swal("There was an error!", "more error details", "warning");
            console.log("Something went wrong!!", err);
          });
      } else {
        setshowerr(true);
      }

      if (noticeStatus === "publish" && radiovalue !== "individual") {
        if (radiovalue !== '') {
          // await getmembers();
          let bodyFormData = "";

          await makeGetRequest("post/getallMembersid/" + radiovalue, bodyFormData)
            .then((response) => {
              if (response.status === 201) {
                for (var i = 0; i < response.data.data.length; i++) {
                  memberArr.push(response.data.data[i].resident_id);
                }
                setMembersIds(memberArr);
                // setShowLoader(false);
              }
              setShowLoader(false);
            })
            .catch((err) => {
              setShowLoader(false);
              swal("There was an error!", "more error details", "warning");
            });

          if (memberArr) {

            // add noti
            inputdata = {
              notice_id: noticeId,
              notice_title: noticeTitle,
              notice_description: noticeDesc,
              attachment: attachment,
              member_id: memberArr,
              notice_visible_flag: radiovalue,
              is_auto_archived: isAutoArchived,
              created_at: new Date(),
            };
            setShowLoader(true)

            await makePostRequest("commonapis/updateNotice", inputdata)
              .then((response) => {
                if (response.status === 201) {
                  swal("Success", "Notice Updated successfully", "success", {
                    timer: 1000,
                    buttons: false,
                  });
                  // window.location.reload();
                  onSubmitModal();
                  setShowLoader(false)
                }
              })
              .catch((err) => {
                setShowLoader(false)
                swal("There was an error!", "more error details", "warning");
                console.log("Something went wrong!!", err);
              });
          }
        }
      }
      // noticeObj.notice_title = noticeTitle;
      // noticeObj.notice_description = noticeDesc;
      // noticeObj.attachment = attachment;
      // noticeObj.is_auto_archived = isAutoArchived;

    } else {
      if (noticeDesc === "") {
        seterrnoticeDesc(true);
        return false;
      } else {
        seterrnoticeDesc(false);
      }
      if (status === "") {
        seterrradio(true);
        return false;
      } else {
        seterrradio(false);

      }

      if (status === "draft" || (radiovalue === "individual" && membersIds.length > 0)) {
        setshowerr(false);
        inputdata = {
          notice_title: noticeTitle,
          notice_description: noticeDesc,
          attachment: attachment,
          member_id: membersIds,
          notice_visible_flag: radiovalue,
          is_auto_archived: isAutoArchived,
          status: status,
        };
        await makePostRequest("commonapis/createNotice", inputdata)
          .then((response) => {
            if (response.data.status === "1") {
              swal("Success", "Notice added successfully", "success", {
                timer: 1000,
                buttons: false,
              });
              // window.location.reload();
              onSubmitModal();
              setShowLoader(false)
            }
          })
          .catch((err) => {
            setShowLoader(false)
            swal("There was an error!", "more error details", "warning");
            console.log("Something went wrong!!", err);
          });
      } else {
        setshowerr(true);
      }

      if (status === "publish" && radiovalue === "") {
        seterrpublish(true);
        return false;
      } else {
        seterrpublish(false);

        if (radiovalue === "all" ||
          radiovalue === "committeeMembers" ||
          radiovalue === "allOwners") {
          // await getmembers();
          let bodyFormData = "";

          await makeGetRequest("post/getallMembersid/" + radiovalue, bodyFormData)
            .then((response) => {
              if (response.status === 201) {
                for (var i = 0; i < response.data.data.length; i++) {
                  memberArr.push(response.data.data[i].resident_id);
                }
                setMembersIds(memberArr);
              }
              setShowLoader(false);
            })
            .catch((err) => {
              setShowLoader(false);
              swal("There was an error!", "more error details", "warning");
            });
          if (memberArr) {
            // add noti
            inputdata = {
              notice_title: noticeTitle,
              notice_description: noticeDesc,
              attachment: attachment,
              member_id: memberArr,
              notice_visible_flag: radiovalue,
              is_auto_archived: isAutoArchived,
              status: status,
            };
            setShowLoader(true)

            await makePostRequest("commonapis/createNotice", inputdata)
              .then((response) => {
                if (response.data.status === "1") {
                  swal("Success", "Notice added successfully", "success", {
                    timer: 1000,
                    buttons: false,
                  });
                  // window.location.reload();
                  onSubmitModal();
                  setShowLoader(false)
                }
              })
              .catch((err) => {
                setShowLoader(false)
                swal("There was an error!", "more error details", "warning");
                console.log("Something went wrong!!", err);
              });

          }
        }
      }
    }
  }

  const handleChangeradio = (e) => {
    seterrpublish(false);
    memberArr.length = 0;
    membersIds.length = 0;
    setIsIndividual(false);
    let selectedVal = e.target.value;

    let userFlag = "";
    setradioValue(selectedVal);
    if (selectedVal == "individual") {
      setIsIndividual(true);
      residentlisting();
    } else {
      if (e.target.value === "Committee Members") {
        userFlag = "committeeMembers";
      } else {
        userFlag = selectedVal;
      }
      setradioValue(userFlag)
      // setShowLoader(true);
      // let bodyFormData = "";

      // makeGetRequest("post/getallMembersid/" + userFlag, bodyFormData)
      //   .then((response) => {
      //     if (response.status === 201) {
      //       for (var i = 0; i < response.data.data.length; i++) {
      //         memberArr.push(response.data.data[i].resident_id);
      //       }
      //       console.log("ggg", memberArr);
      //       setMembersIds(memberArr);
      //       setShowLoader(false);
      //     } else {
      //       setShowLoader(false);
      //       swal("There was an error!", response.message, "warning");
      //     }
      //   })
      //   .catch((err) => {
      //     setShowLoader(false);
      //     swal("There was an error!", "more error details", "warning");
      //   });
    }
  };

  async function getmembers() {
    let bodyFormData = "";

    await makeGetRequest("post/getallMembersid/" + userflg, bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          for (var i = 0; i < response.data.data.length; i++) {
            memberArr.push(response.data.data[i].resident_id);
          }
          console.log("ggg", memberArr);
          setMembersIds(memberArr);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleChangeStatus = (e) => {
    if (e.target.value == "draft") {
      memberArr.length = 0;
      membersIds.length = 0;
      setradioValue("");
    }
    setStatus(e.target.value);
    seterrradio(false);
  };

  const [activeIndex, setActiveIndex] = React.useState();

  // const handleChangeSelectedResident = (residentId) => {
  //   membersIds.push(residentId);
  //   setMembersIds(membersIds);
  //   setActiveIndex(residentId);
  // };

  const handleChangeSelectedResident = (residentId) => {
    // membersIds.push(residentId);
    // setMembersIds(membersIds);
    setshowerr(false);
    setMembersIds((memIds) => {
      const index = memIds.indexOf(residentId);
      if (index !== -1) {
        //remove
        const updatedIds = [...memIds];
        updatedIds.splice(index, 1);
        return updatedIds;
      } else {
        //add
        return [...memIds, residentId];
      }
    });
    setActiveIndex(residentId);

    // console.log('indv ids',membersIds)
  };
  // const handleChangeCheckBox = (e) => {
  //   console.log(e.target.checked);
  //   setIsChecked(e.target.checked);

  //   let inputdata = {
  //     notice_title: noticeTitle,
  //     notice_description: noticeDesc,
  //     // attachment: "https://societyuploads.s3.amazonaws.com/NWLG.png",
  //     attachment:attachment
  //   };
  //   makePostRequest("commonapis/saveNotice", inputdata)
  //     .then((response) => {
  //       if (response.data.status === "1") {
  //         swal("Success", "Notice saved successfully", "success", {
  //           timer: 1000,
  //           buttons: false,
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       swal("There was an error!", "more error details", "warning");
  //       console.log("Something went wrong!!", err);
  //     });
  // };

  // function validateImageOrFile(fileData) {
  //   if (fileData.name.match(/.(pdf)$/i)) return true;
  //   else return false;
  // }

  async function validateImageOrFile(fileData) {
    if (
      fileData.name.match(
        /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
      )
    )
      return true;
    else return false;
  }

  async function uploadfile(e) {
    setDocErrorMsg("")
    const file = e.target.files[0];
    if (await validateImageOrFile(file)) {
      setShowLoader(true);
      var profilePicUrl = await addattachment(file);

      attachment.push(profilePicUrl);
      setAttachment(attachment);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      setDocErrorMsg("Invalid file format");
    }
  }

  async function addattachment(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    let fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
        let filename = response.data.imagepath[0].originalname;
        setFilename(filename);
      }
    );
    return fileUrl;
  }

  async function deleteDocument(index) {
    attachment.splice(index, 1); // 2nd parameter means remove one item only
    setAttachment(attachment);
    setUpload(!Upload);
  }

  const [residentlist, setresidentlist] = React.useState([]);
  const [isEditNotice, setIsEditNotice] = React.useState();

  async function residentlisting() {
    setShowLoader(true);
    let bodyFormData = {
      searchq: q,
      pageNo: "",
      count: "",
      isTenent: "",
    };

    await makePostRequest("resident/residentandtenentlisting", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data.rows;
          setresidentlist(data);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const [noticeObj, setNoticeObj] = React.useState({});
  async function getNoticeById(noticeId) {
    setShowLoader(true);
    await makeGetRequest("commonapis/getNoticebyid/" + noticeId)
      .then((response) => {
        if (response.status == "201") {
          setNoticeObj(response.data.data);
          setnoticeTitle(response.data.data.notice_title);
          setnoticeDesc(response.data.data.notice_description);
          setIsAutoArchived(response.data.data.is_auto_archived);
          setAttachment(response.data.data.attachment);
          setnoticeId(response.data.data.notice_id);
          setnoticeStatus(response.data.data.status);
          setradioValue(response.data.data.notice_visible_flag);
          setMembersIds(response.data.data.member_id);

          if (response.data.data.notice_visible_flag == "individual") {
            residentlisting();
          }
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function updateNotice(status) {
    let dataval = localStorage.getItem("noticeInfoSave");
    let narr = JSON.parse(dataval);

    if (status == "archived") {
      narr.status = status;
      narr.archived_time = new Date();
    } else {
      narr.status = status;
      narr.member_id = membersIds;
      narr.notice_visible_flag = radiovalue;
    }
    await makePostRequest("commonapis/updateNotice", narr)
      .then((response) => {
        if (response.data.status === "1") {
          swal("Success", "Notice sent successfully", "success", {
            timer: 1000,
            buttons: false,
          });
          window.location.reload();
          localStorage.setItem("isEditNotice", false);
          memberArr.length = 0;
          membersIds.length = 0;
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  useEffect(() => {
    setIsEditNotice(localStorage.getItem("isEditNotice"));

    if (localStorage.getItem("isEditNotice")) {
      getNoticeById(localStorage.getItem("editNoticeId"));
    }
  }, []);

  useEffect(() => {
    if (Upload) {
      setUpload(false);
    } else if (q) {
      residentlisting();
    }
  }, [Upload, membersIds, q]);

  const handleEditorChange = (content, editor) => {
    seterrnoticeDesc(false);
    setnoticeDesc(content);
  };

  return (
    <>
      <div id="successfullAdd">
        <Formik
          enableReinitialize
          initialValues={formikInitials}
          validationSchema={Validation_Schema}
          onSubmit={addNoticeBoard}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldTouched,
            touched,
            isValid,
            handleSubmit,
          }) => (
            <Form>
              <Grid container spacing={3} className="addCommitee1">
                <Grid item xs={12} md={12}>
                  <div className="modalInput">
                    <ReceiptOutlinedIcon />
                    <input
                    maxLength={255}
                      className="modalInputSt newModalInputSt"
                      placeholder="Title Of Notice"
                      value={values.noticeTitle}
                      onChange={handleChange("noticeTitle")}
                      onBlur={() => setFieldTouched("noticeTitle")}
                      onChangeCapture={(e) => setnoticeTitle(e.target.value)}
                    />
                  </div>
                  {errors.noticeTitle && touched.noticeTitle ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.noticeTitle}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} md={12}>
                  <Editor
                    value={noticeDesc}
                    // onChangeCapture={(e) =>
                    //   setnoticeDesc(e.target.getContent())
                    // }
                    apiKey="brwlomyki3gc9tg0cfqxjgiy1zgqnfeyzm3kbaakj209n34c"
                    plugins="wordcount"
                    onEditorChange={handleEditorChange}
                    onBlur={(e) => setFieldTouched("noticeDesc")}
                    onChange={handleChange("noticeDesc")}
                  />
                  {errnoticeDesc ? (
                    <div style={{ color: "red" }} className="errorField">
                      {"Required"}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} md={12}>
                  <div className="atchmentMain">
                    <div className="atchMain">
                      <AttachmentOutlinedIcon />
                      <input
                        type="file"
                        id="attachmentid"
                        value={values.attachment}
                        onChange={(event) => uploadfile(event)}
                      />
                      <span>Add attachment</span>
                      <span className="formatNot">
                        Note: format allowed for document- (pdf,image,docs,xls,text)
                      </span>
                    </div>
                  </div>
                  <div className="fileName">
                    {attachment.length > 0 ? (
                      <>
                        {attachment.map((option, index) => (
                          <span className="uploaderFileOut">
                            {option.split("/").pop().replace("%20", " ")}
                            <IconButton>
                              <CloseIcon
                                onClick={() => deleteDocument(index)}
                              />
                            </IconButton>
                          </span>
                        ))}
                      </>
                    ) : (
                      <span>No File uploaded</span>
                    )}
                    {/* <span>sampleimage.jpg</span> */}
                  </div>
                  {docErrorMsg ? (
                    <div className="errorField errorFieldFForLogin forInvalidFile">
                      {docErrorMsg}
                    </div>
                  ) : (
                    <></>
                  )}
                </Grid>

                <Grid item xs={12} md={12}>
                  <div className="newCheckWrapper">
                    <div className="checkOut">
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox defaultChecked />}
                          label="Auto Archive"
                        />
                      </FormGroup>
                      <span className="daysNotice">
                        : Notice will auto archive after 30 days
                      </span>
                    </div>

                    {isEditNotice && noticeStatus == "publish" &&
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={radiovalue}
                        onChange={(e) => handleChangeradio(e)}
                        name="radio-buttons-group"
                        className="modalRadioOutNotic"
                      >
                        <FormControlLabel
                          value="all"
                          control={<Radio />}
                          label="All"
                        />
                        <FormControlLabel
                          value="committeeMembers"
                          control={<Radio />}
                          label="Committee Members"
                        />
                        <FormControlLabel
                          value="allOwners"
                          control={<Radio />}
                          label="All Owners"
                        />
                        <FormControlLabel
                          value="individual"
                          control={<Radio />}
                          label="Individual"
                        />
                      </RadioGroup>
                    }

                    {!isEditNotice &&
                      <div onChange={(e) => handleChangeStatus(e)}>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="female"
                          name="radio-buttons-group"
                          className="modalRadioOutNotic"
                        >
                          <FormControlLabel
                            value="draft"
                            control={<Radio />}
                            label="Add to Draft"
                          />

                          <FormControlLabel
                            value="publish"
                            control={<Radio />}
                            label="Publish"
                          />
                        </RadioGroup>
                        {errradio ? (
                          <div style={{ color: "red" }} className="errorField">
                            {"Required"}
                          </div>
                        ) : null}
                      </div>
                    }
                  </div>
                </Grid>

                <Grid item xs={12} md={12}>
                  {status == "publish" ? (
                    <div onChange={(e) => handleChangeradio(e)}>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        className="modalRadioOutNotic"
                      >
                        <FormControlLabel
                          value="all"
                          control={<Radio />}
                          label="All"
                        />
                        <FormControlLabel
                          value="committeeMembers"
                          control={<Radio />}
                          label="Committee Members"
                        />
                        <FormControlLabel
                          value="allOwners"
                          control={<Radio />}
                          label="All Owners"
                        />
                        <FormControlLabel
                          value="individual"
                          control={<Radio />}
                          label="Individual"
                        />
                      </RadioGroup>
                      {errpublish ? (
                        <div style={{ color: "red" }} className="errorField">
                          {"Required"}
                        </div>
                      ) : null}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Grid>
                <>
                  {status == "publish" && isIndividual && (
                    <Grid item xs={12} md={12}>
                      <div className="visitorSearchDiv visitorSearchDivNotice">
                        <SearchIcon className="visitorSearchIco" />
                        <input
                          type="text"
                          placeholder="Search By Phone Or Name Or Apartment"
                          onChangeCapture={(e) => setQ(e.target.value)}
                        />
                        {/* <MicIcon className="visitorMicIco" /> */}
                      </div>
                      <div className="forNoticeSelectListOuter">
                        {residentlist.map((option) => (
                          <div
                            key={option.resident_id}
                            className={
                              membersIds.includes(option.resident_id)
                                ? "visitContDiv visitContDivNotice selectedTile draftSection"
                                : "visitContDiv visitContDivNotice draftSection"
                            }
                            onClick={() =>
                              handleChangeSelectedResident(option.resident_id)
                            }
                          >
                            <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                              {option.apartment ? (
                                <>
                                  {/* {option.apartment.} */}
                                  {option.apartment.map((resApt, index) => (
                                    <>
                                      {resApt.is_current_stay == true &&
                                        option.user_type == "Resident User" ? (
                                        // {setTempCurrentStay(true)}
                                        <div className="NewTailCountOut miniBox">
                                          <div className="buildingNameNcount">
                                            <p>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[0]
                                              }
                                            </p>
                                            <p>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[1]
                                              }
                                            </p>
                                          </div>
                                          <h1>
                                            {resApt.uniq_apt_name.split("/")[2]}
                                          </h1>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ))}
                                  {option.currentstaycnt.count == 0 &&
                                    option.user_type == "Resident User" ? (
                                    <div className="NewTailCountOut defaultTailCount miniBox">
                                      <div className="buildingNameNcount">
                                        <p>No Apart.</p>
                                        <p>Occupied</p>
                                      </div>
                                      <h1>F-000</h1>
                                    </div>
                                  ) : (
                                    <></>
                                  )}

                                  {option.user_type == "tenent" && (
                                    <>
                                      {option.apartment.map((resApt, index) => (
                                        <div className="NewTailCountOut miniBox">
                                          <div className="buildingNameNcount">
                                            <p>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[0]
                                              }
                                            </p>
                                            <p>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[1]
                                              }
                                            </p>
                                          </div>
                                          <h1>
                                            {resApt.uniq_apt_name.split("/")[2]}
                                          </h1>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <div className="NewTailCountOut defaultTailCount miniBox">
                                    <div className="buildingNameNcount">
                                      <p>No Apart.</p>
                                      <p>Occupied</p>
                                    </div>
                                    <h1>F-000</h1>
                                  </div>
                                </>
                              )}

                              <div className="visitContProf">
                                {option.user_obj.profile_pic ? (
                                  <Zoom>
                                    <img src={option.user_obj.profile_pic} />
                                  </Zoom>
                                ) : (
                                  <img alt="Remy Sharp" src={avtarPic} />
                                )}
                              </div>
                              <div className="visitContLeft">
                                <h3 className="visitContHed">
                                  {option.user_obj.first_name}{" "}
                                  {option.user_obj.last_name}{" "}
                                </h3>
                                <p className="visitContMob">
                                  {option.user_obj.contact_no}
                                </p>
                              </div>
                              {/* {option.apartment ? (
                              <div className="visitBottCont">
                                <p>Flat Number</p>
                                {option.apartment.map((apartmentName) => (
                                  <b>{apartmentName.uniq_apt_name} </b>
                                ))}
                              </div>
                            ) : (
                              <div className="visitBottCont">
                                <p>Flat Number</p>
                              </div>
                            )} */}
                              <div className="visitBottCont forMyTexAlign">
                                {option.apartment ? (
                                  <div>
                                    <>
                                      {option.apartment.map((opt) => (
                                        <>
                                          {(opt.is_current_stay == true ||
                                            opt.occupancy_type == "Vacant") &&
                                            option.user_type ==
                                            "Resident User" ? (
                                            <b className="visitContMob">
                                              {opt.uniq_apt_name}
                                              <em>{opt.occupancy_type}</em>
                                              <br />
                                            </b>
                                          ) : (
                                            <></>
                                          )}

                                          {/* {(option.currentstaycnt.count == 0 && option.user_type == 'Resident User') && (
                                                  <b className="visitContMob">
                                                    vacant
                                                  </b>
                                                )} */}
                                        </>
                                      ))}
                                    </>

                                    {option.user_type == "tenent" && (
                                      <>
                                        {option.apartment.map((opt1, index) => (
                                          <b className="visitContMob">
                                            {opt1.uniq_apt_name}
                                            <em>{opt1.occupancy_type}</em>
                                          </b>
                                        ))}
                                      </>
                                    )}
                                  </div>
                                ) : (
                                  <div>No Apartment Allocated</div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      {showerr ? (
                        <div
                          style={{ color: "red" }}
                          className="errorField"
                        >
                          {"Required"}
                        </div>
                      ) : null}
                    </Grid>
                  )}

                  {((noticeStatus === "publish" && isIndividual) ||
                    (radiovalue == "individual" && isEditNotice)) && (
                      <Grid item xs={12} md={12}>
                        <div className="visitorSearchDiv visitorSearchDivNotice">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            type="text"
                            placeholder="Search By Phone Or Name Or Apartment"
                            onChangeCapture={(e) => setQ(e.target.value)}
                          />
                          {/* <MicIcon className="visitorMicIco" /> */}
                        </div>
                        <div className="forNoticeSelectListOuter">
                          {residentlist.map((option) => (
                            <div
                              key={option.resident_id}
                              className={
                                membersIds.includes(option.resident_id)
                                  ? "visitContDiv visitContDivNotice selectedTile draftSection"
                                  : "visitContDiv visitContDivNotice draftSection"
                              }
                              onClick={() =>
                                handleChangeSelectedResident(option.resident_id)
                              }
                            >
                              <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                                {option.apartment ? (
                                  <>
                                    {/* {option.apartment.} */}
                                    {option.apartment.map((resApt, index) => (
                                      <>
                                        {resApt.is_current_stay == true &&
                                          option.user_type == "Resident User" ? (
                                          // {setTempCurrentStay(true)}
                                          <div className="NewTailCountOut miniBox">
                                            <div className="buildingNameNcount">
                                              <p>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[0]
                                                }
                                              </p>
                                              <p>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[1]
                                                }
                                              </p>
                                            </div>
                                            <h1>
                                              {resApt.uniq_apt_name.split("/")[2]}
                                            </h1>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </>
                                    ))}
                                    {option.currentstaycnt.count == 0 &&
                                      option.user_type == "Resident User" ? (
                                      <div className="NewTailCountOut defaultTailCount miniBox">
                                        <div className="buildingNameNcount">
                                          <p>No Apart.</p>
                                          <p>Occupied</p>
                                        </div>
                                        <h1>F-000</h1>
                                      </div>
                                    ) : (
                                      <></>
                                    )}

                                    {option.user_type == "tenent" && (
                                      <>
                                        {option.apartment.map((resApt, index) => (
                                          <div className="NewTailCountOut miniBox">
                                            <div className="buildingNameNcount">
                                              <p>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[0]
                                                }
                                              </p>
                                              <p>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[1]
                                                }
                                              </p>
                                            </div>
                                            <h1>
                                              {resApt.uniq_apt_name.split("/")[2]}
                                            </h1>
                                          </div>
                                        ))}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <div className="NewTailCountOut defaultTailCount miniBox">
                                      <div className="buildingNameNcount">
                                        <p>No Apart.</p>
                                        <p>Occupied</p>
                                      </div>
                                      <h1>F-000</h1>
                                    </div>
                                  </>
                                )}
                                <div className="visitContProf">
                                  {option.user_obj.profile_pic ? (
                                    <Zoom>
                                      <img src={option.user_obj.profile_pic} />
                                    </Zoom>
                                  ) : (
                                    <img alt="Remy Sharp" src={avtarPic} />
                                  )}
                                </div>
                                <div className="visitContLeft">
                                  <h3 className="visitContHed">
                                    {option.user_obj.first_name}{" "}
                                    {option.user_obj.last_name}{" "}
                                  </h3>
                                  <p className="visitContMob">
                                    {option.user_obj.contact_no}
                                  </p>
                                </div>
                                {/* {option.apartment ? (
                              <div className="visitBottCont">
                                <p>Flat Number</p>
                                {option.apartment.map((apartmentName) => (
                                  <b>{apartmentName.uniq_apt_name} </b>
                                ))}
                              </div>
                            ) : (
                              <div className="visitBottCont">
                                <p>Flat Number</p>
                              </div>
                            )} */}
                                <div className="visitBottCont forMyTexAlign">
                                  {option.apartment ? (
                                    <div>
                                      <>
                                        {option.apartment.map((opt) => (
                                          <>
                                            {(opt.is_current_stay == true ||
                                              opt.occupancy_type == "Vacant") &&
                                              option.user_type ==
                                              "Resident User" ? (
                                              <b className="visitContMob">
                                                {opt.uniq_apt_name}
                                                <em>{opt.occupancy_type}</em>
                                                <br />
                                              </b>
                                            ) : (
                                              <></>
                                            )}

                                            {/* {(option.currentstaycnt.count == 0 && option.user_type == 'Resident User') && (
                                                  <b className="visitContMob">
                                                    vacant
                                                  </b>
                                                )} */}
                                          </>
                                        ))}
                                      </>

                                      {option.user_type == "tenent" && (
                                        <>
                                          {option.apartment.map((opt1, index) => (
                                            <b className="visitContMob">
                                              {opt1.uniq_apt_name}
                                              <em>{opt1.occupancy_type}</em>
                                            </b>
                                          ))}
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    <div>No Apartment Allocated</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        {showerr ? (
                          <div
                            style={{ color: "red" }}
                            className="errorField"
                          >
                            {"Required"}
                          </div>
                        ) : null}
                      </Grid>
                    )}
                </>

                {isEditNotice ? (
                  <>
                    {(status == 'publish' || noticeStatus == "publish") ?
                      <Grid item xs={12} md={12}>
                        <div className="modalMainBtMain">
                          <Button
                            className="modalMainBt"
                            // onClick={(e) => addNoticeBoard(e)}
                            name="publish"
                            type="submit"
                          >
                            Edit And Publish
                          </Button>
                        </div>
                      </Grid> :
                      <Grid item xs={12} md={12}>
                        <div className="modalMainBtMain">
                          <Button
                            className="modalMainBt"
                            // onClick={(e) => addNoticeBoard(e)}
                            name="publish"
                            type="submit"
                          >
                            Edit
                          </Button>
                        </div>
                      </Grid>}</>
                ) : (
                  <Grid item xs={12} md={12}>
                    {status == "publish" ? (
                      <div className="modalMainBtMain">
                        <Button
                          className="modalMainBt"
                          // onClick={(e) => addNoticeBoard(e)}
                          name="publish"
                          type="submit"
                        >
                          Publish
                        </Button>
                      </div>
                    ) : (
                      <div className="modalMainBtMain">
                        <Button
                          className="modalMainBt"
                          // onClick={(e) => addNoticeBoard(e)}
                          name="saved"
                          type="submit"
                        >
                          Save
                        </Button>
                      </div>
                    )}
                  </Grid>
                )}
              </Grid>
            </Form>
          )}
        </Formik>
        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
              <h4>Success !</h4>
              <p>
                Notice Created <br />
                successfully
              </p>
            </div>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
export default CreateNoticeModal;
